module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#online-news",
      toString: function () {
        return this.url;
      }
    }